'use strict';

import signTemplate from './signup.html';
import Signin from './signup.ctrl';

function signupRouter($stateProvider) {
  $stateProvider
    .state('signup', {
      url: '/signup?:email',
      template: signTemplate,
      controller: 'SignupController as vm',
      resolve: {
        checkTranslationFilesLoaded: (I18nService) => {
          return I18nService.ensureLoaded();
        }
      }
    });
}

export default angular
  .module('signup.router', [
    Signin
  ])
  .config(signupRouter)
  .name;
